import { Phone, CreditCard, Loader2, Inbox } from "lucide-react";
import { Badge } from "../ui/badge";
import { fmtDate } from "./leadUtils";

const paymentColors = {
  paid: "bg-green-600/20 text-green-400 border-green-500/40",
  initiated: "bg-yellow-600/20 text-yellow-400 border-yellow-500/40",
  expired: "bg-zinc-600/20 text-zinc-400 border-zinc-500/40",
};

export const PaymentsList = ({ payments, loading }) => {
  if (loading) {
    return (
      <div className="flex justify-center py-24"><Loader2 className="h-8 w-8 animate-spin text-blue-500" /></div>
    );
  }
  if (payments.length === 0) {
    return (
      <div data-testid="payments-empty-state" className="text-center py-24 text-zinc-500">
        <Inbox className="h-12 w-12 mx-auto mb-4 text-zinc-700" />
        No payments yet.
      </div>
    );
  }
  return (
    <div className="space-y-3" data-testid="payments-list">
      {payments.map((p) => (
        <div
          key={p.id}
          data-testid={`payment-row-${p.id}`}
          className="bg-[#121212] border border-zinc-800 rounded-xl p-4 sm:p-5 grid grid-cols-1 sm:grid-cols-12 gap-4 items-start sm:items-center"
        >
          <div className="sm:col-span-4">
            <div className="font-heading font-semibold text-white">{p.customer_name}</div>
            <a
              data-testid={`payment-phone-${p.id}`}
              href={`tel:${(p.customer_phone || "").replace(/[^+\d]/g, "")}`}
              className="inline-flex items-center gap-1.5 text-blue-400 hover:text-blue-300 text-sm mt-0.5"
            >
              <Phone className="h-3.5 w-3.5" /> {p.customer_phone}
            </a>
          </div>
          <div className="sm:col-span-3">
            <div className="inline-flex items-center gap-1.5 text-zinc-300 text-sm">
              <CreditCard className="h-3.5 w-3.5 text-blue-500" /> {p.package_name || "Service Payment"}
            </div>
            <div className="text-zinc-600 text-xs mt-0.5">{fmtDate(p.created_at)}</div>
          </div>
          <div className="sm:col-span-2">
            <div className="font-heading text-xl font-bold text-white" data-testid={`payment-amount-${p.id}`}>
              ${Number(p.amount).toFixed(2)}
            </div>
          </div>
          <div className="sm:col-span-3 flex sm:justify-end">
            <Badge
              variant="outline"
              className={`${paymentColors[p.payment_status] || paymentColors.initiated} rounded-sm`}
              data-testid={`payment-status-${p.id}`}
            >
              {p.payment_status === "paid" ? `Paid${p.paid_at ? " · " + fmtDate(p.paid_at) : ""}` : p.payment_status}
            </Badge>
          </div>
        </div>
      ))}
    </div>
  );
};
